import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';

function Dropzone({ image, onDrop, name }) {

  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    onDrop: acceptedFiles => {
      onDrop(acceptedFiles);
    },
    accept: { 'image/*': ['.jpeg', '.png'] },
  });
  return (
    <div {...getRootProps({ className: 'd-flex align-items-center justify-content-center dropzone p-0 overflow-hidden' })} style={{height: 200}}>
      <input className='input-zone' {...getInputProps()} />
      {image ? ( 
        <img
          src={image}

          onLoad={() => {
            URL.revokeObjectURL(image);
          }}
          className='w-100 h-auto'
        />

      ) : (
        <div className='text-center p-4'>
          <p className='dropzone-content'>Drag and Drop {name && `your ${name}`} here OR Browse files</p>
          <p className='dropzone-content mb-0'>Accepted file types: png, jpg</p>
        </div>
      )}
    </div>
  );
}

export default Dropzone;
